import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastComponent } from './toast.component';
import { IconModule } from '../icon/icon.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TextModule } from '../text/text.module';
import { TitleModule } from '../title/title.module';
import { ButtonModule } from '../button/button.module'
import { CloseActionModule } from '../close-action/close-action.module';

@NgModule({
  declarations: [ToastComponent],
  imports: [CommonModule, IconModule, BrowserAnimationsModule, TextModule, TitleModule, ButtonModule, CloseActionModule],
  exports: [ToastComponent],
})
export class ToastModule {}
